import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as actions from './actions'
import common from './modules/common'
import job from './modules/job'
import account from './modules/account'
import notification from './modules/notification'
import onboarding from './modules/onboarding'
import microSite from './modules/microSite'
import onboardingManagement from './modules/onboardingManagement'
import satisfactionSurveyManagement from './modules/satisfactionSurveyManagement'
import postApplicantManagement from './modules/postApplicantManagement'
import jobApplicationManagement from './modules/jobApplicationManagement'
import crm from './modules/crm'
import chatbot from './modules/chatbot'
import survey from './modules/survey'
import jobCustomField from './modules/jobCustomField'
import hrDashboard from './modules/hrDashboard'
import joywok from './modules/joywok'
import company from './modules/company'
import eventTrack from './modules/eventTrack'
import wechat from './modules/wechat'
import jobPosting from './modules/jobPosting'
import jobReferralManagement from './modules/jobReferralManagement'
import personal from './modules/personal'
import referral from './modules/referral'
import questionnaire from './modules/questionnaire'
import application from './modules/application'
import openQuestion from './modules/openQuestion'
import questionTree from './modules/questionTree'
import jobTemplate from './modules/jobTemplate'
import jobManagement from './modules/jobManagement'
import worldLocation from './modules/worldLocation'
import auditLog from './modules/auditLog'
import hm from './modules/hm'
import sourceCode from './modules/sourceCode'
import rpa from './modules/rpa'
import resumeLockConfig from './modules/resumeLockConfig'
import applicantStatusAutoChangeConfig from './modules/applicantStatusAutoChangeConfig'
import applicantStatusNotificationTemplateConfig from './modules/applicantStatusNotificationTemplateConfig'
import agency from './modules/agency'
import alumniManagement from './modules/alumniManagement'
import userManagement from './modules/userManagement'
import roleManagement from './modules/roleManagement'
import companyManagement from './modules/companyManagement'
import employeeManagement from './modules/employeeManagement'
import agreement from './modules/agreement'
import notificationTemplate from './modules/notificationTemplate'
import candidateStatus from './modules/candidateStatus'
import interview from './modules/interview'
import talent from './modules/talent'
import potential from './modules/potential'
import apScheduler from './modules/apScheduler'
import microsoftGraph from './modules/microsoftGraph'
import resourceLibrary from './modules/resourceLibrary'
import jobPosterAmbassador from './modules/jobPosterAmbassador'
import chartReport from './modules/chartReport'
import openApi from './modules/openApi'
import ai from './modules/ai'
import aiChatbot from './modules/aiChatbot'
import superAdmin from './modules/superAdmin'
import offerLetter from './modules/offerLetter'
import siteMessage from './modules/siteMessage'
import adsTier from './modules/adsTier'
import uploadData from './modules/uploadData'
import bi from './modules/bi'
import companyCulture from './modules/companyCulture'
import cashPointsManagement from './modules/cashPointsManagement'
import schoolManagement from './modules/schoolManagement'
import majorManagement from './modules/majorManagement'
import jobPostingChannelAccount from './modules/jobPostingChannelAccount'
import interviewMeetingRoom from './modules/interviewMeetingRoom'
import resumeVector from './modules/resumeVector'
import talentRecommendation from './modules/talentRecommendation'
import metaInfo from './modules/metaInfo'
import jobFit from './modules/jobFit'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    job,
    account,
    notification,
    onboarding,
    microSite,
    onboardingManagement,
    satisfactionSurveyManagement,
    postApplicantManagement,
    jobApplicationManagement,
    crm,
    chatbot,
    survey,
    jobCustomField,
    hrDashboard,
    joywok,
    company,
    eventTrack,
    wechat,
    jobPosting,
    jobReferralManagement,
    personal,
    referral,
    questionnaire,
    application,
    openQuestion,
    questionTree,
    jobTemplate,
    jobManagement,
    worldLocation,
    auditLog,
    sourceCode,
    hm,
    rpa,
    resumeLockConfig,
    applicantStatusAutoChangeConfig,
    applicantStatusNotificationTemplateConfig,
    agency,
    userManagement,
    roleManagement,
    companyManagement,
    alumniManagement,
    employeeManagement,
    agreement,
    notificationTemplate,
    candidateStatus,
    interview,
    talent,
    potential,
    apScheduler,
    microsoftGraph,
    resourceLibrary,
    jobPosterAmbassador,
    chartReport,
    openApi,
    ai,
    aiChatbot,
    superAdmin,
    offerLetter,
    siteMessage,
    adsTier,
    uploadData,
    bi,
    companyCulture,
    cashPointsManagement,
    schoolManagement,
    jobPostingChannelAccount,
    majorManagement,
    interviewMeetingRoom,
    resumeVector,
    talentRecommendation,
    metaInfo,
    jobFit
  },
  actions,
  plugins: [createPersistedState({
    filter: ({ type, payload }) => {
      if (type.includes('microSite/')) {
        if (type.includes('SAVE_CONFIG_LOCAL')) {
          return true
        }
        return false
      }
      return true
    },
    reducer (state) {
      return {
        ...state,
        microSite: {
          siteData: state.microSite.siteData
        }
      }
    }
  })]
})
